<script>
// others
import LanguageFlag from '@src/components/language-flag/language-flag.vue'
import LocationInfo from '@src/components/location-info/_location-info.vue'
import UserInfo from '@src/components/user-info/_user-info.vue'
import PageTitle from '@src/components/page-title/_page-title.vue'

export default {
    components: {
        'language-flag': LanguageFlag,
        'location-info': LocationInfo,
        'user-info': UserInfo,
        'page-title': PageTitle,
    },
    props: {
        hideTitle: { type: Boolean, default: false },
    },
    data() {
        return {
            isHeaderOpen: false,
            isMenuOpen: false,
        }
    },
    methods: {
        openMenu() {
            // console.log('menu')
        },
    },
}
</script>

<template>
    <div class="header-title">
        <header class="header">
            <b-container class="header-mobile">
                <b-row>
                    <div class="header__responsive-container">
                        <b-col>
                            <mgb-button
                                class="header__responsive-container--menuButton"
                                @click.prevent="isMenuOpen = !isMenuOpen"
                            >
                                <svgicon
                                    width="20"
                                    height="20"
                                    icon="icn_menu"
                                ></svgicon>
                            </mgb-button>
                        </b-col>
                        <b-col>
                            <div class="header__responsive-container--mgbImage">
                                <img src="@assets/images/logos/logo-mgb.png" />
                            </div>
                        </b-col>
                        <b-col>
                            <mgb-button
                                class="header__responsive-container--menuButton"
                                @click.prevent="isHeaderOpen = !isHeaderOpen"
                            >
                                <svgicon
                                    width="20"
                                    height="20"
                                    icon="icn_admin"
                                ></svgicon>
                            </mgb-button>
                        </b-col>
                    </div>
                </b-row>
            </b-container>

            <div class="header__section" :class="{ opened: isHeaderOpen }">
                <b-container class="header__section--container">
                    <b-row class="header__section--row">
                        <div class="header__section--item">
                            <language-flag />
                        </div>
                        <div class="header__section--item">
                            <location-info />
                        </div>
                        <div class="header__section--item">
                            <user-info />
                        </div>
                    </b-row>
                </b-container>
            </div>
        </header>
        <page-title v-if="!hideTitle" />
    </div>
</template>

<style lang="scss" scoped>
@import '@src/design/components/header';
</style>
